import React, { useState, useEffect } from 'react';
import { db, auth } from '../../firebase';
import { ref, onValue, update } from 'firebase/database';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FaArrowLeft } from 'react-icons/fa';

const AuditEngineerDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({
        surname: '',
        firstName: '',
        middleName: '',
        whatsappNo: '',
        email: '',
        dob: '',
        birthPlace: '',
        taluka: '',
        technicalQualification: '',
        trade: '',
        aadharNo: '',
        panNo: '',
        gstNo: '',
        societyName: '',
        universityName: '',
        passingYear: '',
        businessLocation: '',
        bankName: '',
        address: '',
        bankAddress: ''
    });

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (!user) navigate('/login');
        });

        if (id) {
            const engineerRef = ref(db, `ekamwatapzp/EngineerRegistrations/${id}`);
            const unsubData = onValue(engineerRef, (snapshot) => {
                if (snapshot.exists()) {
                    setFormData(prev => ({ ...prev, ...snapshot.val() }));
                } else {
                    toast.error("Engineer data not found");
                    navigate('/audit/engineers/new');
                }
                setLoading(false);
            });

            return () => {
                unsubscribe();
                unsubData();
            };
        }
    }, [id, navigate]);

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#1a1a4d]"></div>
            </div>
        );
    }

    return (
        <div className="p-4 md:p-8 bg-[#f4f7fe] min-h-screen font-sans">
            {/* Header Area */}
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 gap-4">
                <div className="flex items-center gap-4">
                    <button 
                        onClick={() => navigate(-1)}
                        className="p-2.5 bg-white rounded-lg shadow-sm border border-gray-100 text-[#1a1a4d] hover:bg-gray-50 transition active:scale-95"
                        title="Back"
                    >
                        <FaArrowLeft />
                    </button>
                    <h1 className="text-xl font-bold text-gray-800">अर्ज फॉर्म पहा (Audit)</h1>
                </div>
                <div className="text-sm font-medium text-gray-500">
                    सांगली जिल्हा परिषद  /  <span className="text-gray-400">अर्ज फॉर्म पहा</span>
                </div>
            </div>

            {/* Form Card */}
            <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-8">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    
                    {/* Surname */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700 flex items-center gap-1">
                            अर्जदार आडनाव
                        </label>
                        <input 
                            type="text" name="surname" value={formData.surname} readOnly
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm bg-gray-50 outline-none transition"
                        />
                    </div>

                    {/* First Name */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700 flex items-center gap-1">
                            पहिले नाव
                        </label>
                        <input 
                            type="text" name="firstName" value={formData.firstName} readOnly
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm bg-gray-50 outline-none transition"
                        />
                    </div>

                    {/* Middle Name */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700 flex items-center gap-1">
                            वडीलांचे नांव
                        </label>
                        <input 
                            type="text" name="middleName" value={formData.middleName} readOnly
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm bg-gray-50 outline-none transition"
                        />
                    </div>

                    {/* WhatsApp */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700 flex items-center gap-1">
                            व्हॉट्सॲप नंबर
                        </label>
                        <input 
                            type="text" name="whatsappNo" value={formData.whatsappNo} readOnly
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm bg-gray-50 outline-none transition"
                        />
                    </div>

                    {/* Email */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700 flex items-center gap-1">
                            ई - मेल आयडी
                        </label>
                        <input 
                            type="email" name="email" value={formData.email} readOnly
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm bg-gray-50 outline-none transition"
                        />
                    </div>

                    {/* DOB */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700 flex items-center gap-1">
                            जन्मतारीख
                        </label>
                        <input 
                            type="text" name="dob" value={formData.dob} readOnly
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm bg-gray-50 outline-none transition"
                        />
                    </div>

                    {/* Birth Place */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700">जन्म स्थान</label>
                        <input 
                            type="text" name="birthPlace" value={formData.birthPlace} readOnly
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm bg-gray-50 outline-none transition"
                        />
                    </div>

                    {/* Taluka */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700 flex items-center gap-1">
                            तालुका
                        </label>
                        <input 
                            type="text" name="taluka" value={formData.taluka} readOnly
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm bg-gray-50 outline-none transition"
                        />
                    </div>

                    {/* Technical Qualification */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700 flex items-center gap-1">
                            तांत्रिक पात्रता
                        </label>
                        <input 
                            type="text" name="technicalQualification" value={formData.technicalQualification} readOnly
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm bg-gray-50 outline-none transition"
                        />
                    </div>

                    {/* Trade */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700 flex items-center gap-1">
                            ट्रेड
                        </label>
                        <input 
                            type="text" name="trade" value={formData.trade} readOnly
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm bg-gray-50 outline-none transition"
                        />
                    </div>

                    {/* Aadhar */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700">आधार क्रमांक</label>
                        <input 
                            type="text" name="aadharNo" value={formData.aadharNo} readOnly
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm bg-gray-50 outline-none transition"
                        />
                    </div>

                    {/* PAN */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700">पॅन क्रमांक</label>
                        <input 
                            type="text" name="panNo" value={formData.panNo} readOnly
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm bg-gray-50 outline-none transition"
                        />
                    </div>

                    {/* GST */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700">जी.एस.टी क्रमांक</label>
                        <input 
                            type="text" name="gstNo" value={formData.gstNo} readOnly
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm bg-gray-50 outline-none transition"
                        />
                    </div>

                    {/* Society Name */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700">संस्थेचे नाव</label>
                        <input 
                            type="text" name="societyName" value={formData.societyName} readOnly
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm bg-gray-50 outline-none transition"
                        />
                    </div>

                    {/* University Name */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700">विद्यापीठाचे नाव</label>
                        <input 
                            type="text" name="universityName" value={formData.universityName} readOnly
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm bg-gray-50 outline-none transition"
                        />
                    </div>

                    {/* Passing Year */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700">उत्तीर्ण वर्ष</label>
                        <input 
                            type="text" name="passingYear" value={formData.passingYear} readOnly
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm bg-gray-50 outline-none transition"
                        />
                    </div>

                    {/* Business Location */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700 flex items-center gap-1">
                            व्यवसायाचे ठिकाण
                        </label>
                        <input 
                            type="text" name="businessLocation" value={formData.businessLocation} readOnly
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm bg-gray-50 outline-none transition"
                        />
                    </div>

                    {/* Bank Name */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700 flex items-center gap-1">
                            बँकेचे नाव
                        </label>
                        <input 
                            type="text" name="bankName" value={formData.bankName} readOnly
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm bg-gray-50 outline-none transition"
                        />
                    </div>

                    {/* Address */}
                    <div className="md:col-span-3 space-y-2">
                        <label className="text-[13px] font-bold text-gray-700 flex items-center gap-1">
                            सध्याचा पत्ता
                        </label>
                        <textarea 
                            name="address" value={formData.address} readOnly
                            rows="3"
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm bg-gray-50 outline-none transition resize-none"
                        ></textarea>
                    </div>

                    {/* Bank Address */}
                    <div className="md:col-span-3 space-y-2">
                        <label className="text-[13px] font-bold text-gray-700">बँकेचा पत्ता</label>
                        <textarea 
                            name="bankAddress" value={formData.bankAddress} readOnly
                            rows="2"
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm bg-gray-50 outline-none transition resize-none"
                        ></textarea>
                    </div>

                    {/* Action Buttons */}
                    <div className="md:col-span-3 flex items-center gap-3 pt-4">
                        <button 
                            type="button"
                            onClick={() => navigate(-1)}
                            className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-2.5 rounded-lg text-sm font-bold transition shadow-md active:scale-95"
                        >
                            बंद करा
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AuditEngineerDetails;
